import dayjs from 'dayjs';

export const REGEX = {
  email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
};

export function isEmpty(value: any): boolean {
  return value === undefined || value === null || value === '';
}

export function isValidEmail(email: string): boolean {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
}

export function isValidNumber(value: any): boolean {
  if (isEmpty(value)) {
    return false;
  }

  if (typeof value === 'number' && !isNaN(value)) {
    return true;
  }

  if (typeof value === 'string') {
    const numberValue = parseFloat(value);
    return !isNaN(numberValue);
  }

  return false;
}

export function isNumberBetween1And100(value) {
  // Convert to a Number (in case it's a string)
  const num = Number(value);

  // Check if it's not NaN and within the desired range
  return !isNaN(num) && num >= 1 && num <= 100;
}

export function isValidString(value: any): boolean {
  return typeof value === 'string';
}

export function minCharacters(value: string, minLength: number): boolean {
  return isValidString(value) && value.length >= minLength;
}

export function maxCharacters(input: string, maxLength: number): boolean {
  return isValidString(input) && input.length < maxLength;
}

export function isDateBetween(dateX: Date, dateY: Date, dateZ: Date): boolean {
  const x = dateX.getTime();
  const y = dateY.getTime();
  const z = dateZ.getTime();

  return x >= y && x <= z;
}

export function greaterThanInclusive(dateA: Date, dateB: Date): boolean {
  return dateA.getTime() >= dateB.getTime();
}

export function lessThanInclusive(dateA: Date, dateB: Date): boolean {
  return dateA.getTime() <= dateB.getTime();
}

export function validateRoute(route: string = '') {
  // Trim whitespace from both ends of the input
  const trimmedRoute = route.trim();

  // 1. Check if the route starts with a forward slash '/'
  if (!trimmedRoute.startsWith('/')) {
    return 'Route must start with a "/".';
  }

  // 2. Check if the route is just the root '/'

  // 3. Check for multiple consecutive slashes '//'
  if (/\/{2,}/.test(trimmedRoute)) {
    return 'Route cannot contain multiple consecutive slashes "//".';
  }

  // 4. Define a regular expression to validate route segments
  //    - Each segment starts with '/' followed by allowed characters
  //    - Allowed characters: alphanumerics, dashes '-', underscores '_', and parameters like ':id'
  //    - Parameters are prefixed with ':' and followed by one or more allowed characters
  const segmentRegex = /^\/(?:[A-Za-z0-9-_]+|:[A-Za-z0-9-_]+)+$/;

  // 5. Split the route into segments and validate each segment
  const segments = trimmedRoute
    .split('/')
    .filter((segment) => segment.length > 0);

  for (const segment of segments) {
    if (!segmentRegex.test(`/${segment}`)) {
      return `Invalid segment "${segment}". Segments can only contain alphanumerics, dashes "-", underscores "_", or be dynamic parameters like ":id".`;
    }
  }

  // 6. (Optional) Check for trailing slash (excluding root)
  // Uncomment the following lines if trailing slashes are not allowed
  /*
      if (trimmedRoute !== '/' && trimmedRoute.endsWith('/')) {
        return 'Route should not have a trailing slash "/".';
      }
      */

  // If all checks pass, return an empty string indicating the route is valid
  return '';
}
